import apiClient from '@/services/rest-api-identity/apiClient'

const baseEndpoint = '/send-verification-user'

export const sendVerificationUser = async (data) => {
  const response = await apiClient({
    method: 'POST',
    url: baseEndpoint,
    data,
  })

  return response?.data
}

export const sendEmailVerification = async (data) => {
  const response = await apiClient({
    method: 'POST',
    url: baseEndpoint,
    data,
  })

  return response?.data
}
